// extracted by mini-css-extract-plugin
module.exports = {"root":"SubscriptionOptionCard_root__7M4YP","body":"SubscriptionOptionCard_body__zq4uD"};